enum PlanInterval {
  YEAR = 'YEAR',
  MONTH = 'MONTH',
  TWO_YEARS = 'TWO_YEARS',
  THREE_YEARS = 'THREE_YEARS',
}

namespace PlanInterval {
  export const fromString = (str: string) => {
    if (str === 'MONTH') {
      return PlanInterval.MONTH;
    }
    if (str === 'YEAR') {
      return PlanInterval.YEAR;
    }
    return (PlanInterval as any)[str];
  };

  export const getPlanIntervalName = (planInterval: PlanInterval) => {
    switch (planInterval) {
      case PlanInterval.YEAR:
        return 'Annual';
      case PlanInterval.MONTH:
        return 'Monthly';
      case PlanInterval.TWO_YEARS:
        return '2 years';
      case PlanInterval.THREE_YEARS:
        return '3 years';
      default:
        return '-';
    }
  };

  export const getPlanIntervalCode = (planInterval: PlanInterval) => {
    switch (planInterval) {
      case PlanInterval.YEAR:
        return 'annual';
      case PlanInterval.MONTH:
        return 'monthly';
      case PlanInterval.TWO_YEARS:
        return '2years';
      case PlanInterval.THREE_YEARS:
        return '3years';
      default:
        return '-';
    }
  };

  export const getIntervalFromPlanCode = (planCode: string) => {
    if (planCode.includes('monthly')) {
      return PlanInterval.MONTH;
    }
    if (planCode.includes('2years')) {
      return PlanInterval.TWO_YEARS;
    }
    if (planCode.includes('3years')) {
      return PlanInterval.THREE_YEARS;
    }
    return PlanInterval.YEAR;
  };

  export const getCycle = (planInterval: PlanInterval) => {
    switch (planInterval) {
      case PlanInterval.YEAR:
        return 'year';
      case PlanInterval.MONTH:
        return 'month';
      case PlanInterval.TWO_YEARS:
        return '2 years';
      case PlanInterval.THREE_YEARS:
        return '3 years';
      default:
        return '1 year';
    }
  };
}

export { PlanInterval };
